import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./features/counter/counterSlice";
import authReducer from "./features/auth/authSlice";
import panchangReducer from "./features/panchang/slice";
import samvatReducer from "./features/samvat/slice";
import laganReducer from "./features/lagan/slice";
import nakshtraReducer from "./features/nakshtra/slice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    samvat: samvatReducer,
    panchang: panchangReducer,
    lagan: laganReducer,
    nakshtra: nakshtraReducer,
  },
});
